import { format, parseISO } from "date-fns";

import type { ScoresEveryDayBrandItem } from "../../../types/scores";
import type { ScoreWeekly } from "../types";
import type { ScoreDailyAverageResponse } from "../response.types";
import { aggregateBrandEveryDaySummaryByBrand } from "./brandEveryDayFromRows";

function rowDate(created_at: string): string {
  const d = parseISO(created_at);
  return Number.isNaN(d.getTime()) ? created_at.slice(0, 10) : format(d, "yyyy-MM-dd");
}

/**
 * Builds a `ScoreWeekly`-shaped object from `dailyAveragePrompt` series (same 7d / WoW logic as brands).
 */
export function scoreWeeklyFromDailyPromptSeries(
  brandId: number,
  promptId: number,
  item: ScoresEveryDayBrandItem | undefined,
): ScoreWeekly | null {
  const pts = item?.scores;
  if (!pts?.length) return null;

  const rows: ScoreDailyAverageResponse[] = pts.map((s) => ({
    date: rowDate(s.created_at),
    brand_id: brandId,
    prompt_id: promptId,
    model_id: 0,
    avg_visibility_score: s.visibility,
    avg_sentiment_score: s.sentiment,
    avg_position: s.ranking,
  }));

  const summary = aggregateBrandEveryDaySummaryByBrand(rows)[brandId];
  if (!summary) return null;

  return {
    brand_id: summary.brand_id,
    brand_name: "",
    prompt_id: promptId,
    model_id: 0,
    current_week_avg_visibility: summary.avg_visibility,
    week_difference_visibility: summary.week_difference_visibility,
    current_week_avg_sentiment: summary.avg_sentiment,
    week_difference_sentiment: summary.week_difference_sentiment,
    current_week_avg_position: summary.avg_position,
    week_difference_position: summary.week_difference_position,
  };
}
